import Vue from 'vue';
import MallOrderStatuses from '@/plugins/graphql/queries/v2/store_management/mall-order-statuses.gql';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import SearchMixin from '@/helpers/vue_mixins/v2/SearchMixin';
import { OrderStatusModel } from '@/helpers/entities/models/OrderStatusModel';
import { DEBOUNCE, PER_PAGE } from '@/helpers/constants/app';
import { debounce } from 'lodash';
export default Vue.extend({
    mixins: [SearchMixin, PaginatorMixin],
    apollo: {
        orders: {
            query: MallOrderStatuses,
            variables() {
                return {
                    appUuid: this.appUuid,
                    after: this.startCursor,
                    first: this.perPage,
                    keyword: this.search,
                };
            },
            update(data) {
                const orderStatuses = data.mallOrderStatuses.edges;
                const orderStatusNodes = (orderStatus) => {
                    return new OrderStatusModel(orderStatus.node);
                };
                return orderStatuses.map(orderStatusNodes);
            },
            result({ data }) {
                const self = this;
                const query = data.orderStatuses;
                self.totalCount = query.totalCount;
                self.pageInfo = query.pageInfo;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            orders: null,
        };
    },
    computed: {
        perPage() {
            return PER_PAGE;
        },
        requestOnFlight() {
            return this.$apollo.loading;
        },
    },
    methods: {
        searchBy(keyword) {
            const self = this;
            self.pageInfo.startCursor = '';
            self.onSearch(keyword);
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                orders: self.orders,
                pageInfo: self.pageInfo,
                totalCount: self.totalCount,
                fetchRecordsFrom: self.fetchRecordsFrom,
                requestOnFlight: self.requestOnFlight,
                onSearch: debounce(self.searchBy, DEBOUNCE),
            });
        }
    },
});
